import { render, staticRenderFns } from "./QueuesList.vue?vue&type=template&id=acfdc8aa&scoped=true&"
import script from "./QueuesList.vue?vue&type=script&lang=js&"
export * from "./QueuesList.vue?vue&type=script&lang=js&"
import style0 from "./QueuesList.vue?vue&type=style&index=0&id=acfdc8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfdc8aa",
  null
  
)

export default component.exports